import SimpleCrypto from 'simple-crypto-js';

const crypto = new SimpleCrypto('fqy$secret');

export const saveIntoSessionStorage = (name, value) => {
  sessionStorage.setItem(name, crypto.encrypt(value));
};

export const getFromSessionStorage = (name) => crypto.decrypt(sessionStorage.getItem(name));
